import $ from 'jquery';
import { getTotalIMSTargetedSelected } from '../showroom/showroom-utilities.js';
import { convertStrToMilitaryTime, hasAttr } from '../utilities.js';
import { Formatter } from '@dealersites/dealersite-js-core';
import MicroModal from 'micromodal';

$('.js-masonry-item').each(function () {
  const $item = $(this);
  const srcUrl = $item.data('url');

  const galleryImage = new Image();

  galleryImage.onload = () => {
    $item.find('.js-image-item').removeClass('opacity-0');
    $item.removeClass('placeholder-image');
  };

  galleryImage.onerror = () => {};
  galleryImage.src = srcUrl;
});

const galleryID = 'vdp-gallery-slider';
const $vdpGallerySlider = $(`.${galleryID}`);
const $vdpGalleryPreviewSlider = $(`.${galleryID}-for`);

$vdpGallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $(`.controls-dots-${galleryID}`).data('theme');
    dots.addClass('slick-dot ' + theme);
  }
});

$vdpGallerySlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  speed: 200,
  touchThreshold: 100,
  asNavFor: `.${galleryID}-for`,
  appendDots: $(`.controls-dots-${galleryID}`),
  nextArrow: $(`.controls-next-${galleryID}`),
  prevArrow: $(`.controls-prev-${galleryID}`),
});

$vdpGalleryPreviewSlider.slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: `.${galleryID}`,
  focusOnSelect: true,
  centerMode: true,
  dots: false,
  speed: 200,
  touchThreshold: 100,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5,
        dots: false,
        centerMode: true,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 3,
        dots: false,
        centerMode: true,
      },
    },
  ],
});

const similarGalleryID = 'vdp-similar-slider';
const $vdpSimilarSlider = $(`.${similarGalleryID}`);

if ($vdpSimilarSlider.length != 0) {
  const $similarCurrentSlide = $(`.controls-current-${similarGalleryID}`);

  $vdpSimilarSlider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    infinite: true,
    nextArrow: $(`.controls-next-${similarGalleryID}`),
    prevArrow: $(`.controls-prev-${similarGalleryID}`),
    responsive: [
      {
        breakpoint: 1590,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '8%',
        },
      },
    ],
  });

  // sets position
  $vdpSimilarSlider.on('init beforeChange afterChange', function (event, slick) {
    $vdpSimilarSlider.slick('setPosition');
  });

  // Adjusts height of all slides to the tallest one
  $vdpSimilarSlider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });

  $vdpSimilarSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
    if (slick.slideCount > 1) {
      const current = (currentSlide ? currentSlide : 0) + 1;
      if ($similarCurrentSlide.length != 0) {
        $similarCurrentSlide.text(current + '/' + slick.slideCount);
      }
    } else {
      $similarCurrentSlide.remove();
    }
  });
}

// VDP Price Card Targeted Incentive Handling

$('.vdp-targeted-incentives .js-targeted-incentive').on('change', function () {
  const $breakdown = $('.js-vdp-breakdown-data');

  // G - Total Targeted Cash of checked/selected
  const totalCashTargeted = getTotalIMSTargetedSelected('cash');

  // A-0 - Final Price (pre tax)
  const pricePreTax = $breakdown.data('price-pre-tax');

  // A-0 - new Final Price (pre tax) with Targeted Cash deducted
  let price = pricePreTax - totalCashTargeted;

  // C - check for tax adjustment
  const hasTax = hasAttr($breakdown, 'data-has-tax');

  if (hasTax) {
    const taxRate = $breakdown.data('tax-rate');
    // C - new Estimated Tax
    const estimatedTax = price * (taxRate / 100);
    // C - update Estimated Tax
    const $estimatedTax = $('.js-estimated-tax');
    $estimatedTax.text('+' + Formatter.price(estimatedTax, 0));
    // A - new Final Price with Tax
    price = price + estimatedTax;
  }

  // A - update Final Prices
  const $finalPrices = $('.js-final-price');

  $finalPrices.each(function () {
    $(this).text(Formatter.price(price, 0));
  });
});

// TO DO: when slider is not active, pause video

document.addEventListener('DOMContentLoaded', () => {
  const $galleryVideoContainer = $vdpGallerySlider.find('.masonry-gallery__item-video');
  const $galleryVideo = $galleryVideoContainer.find('.video');
  let ytPLAYER = {};
  let video = {};
  let type = '';

  if ($galleryVideo.length != 0) {
    let APIReady = false;
    // console.log('this vdp has a video in the gallery');

    video = $galleryVideo[0];
    type = 'youtube';
    const videoId = $galleryVideo.attr('id');
    let youtubeScriptId = 'youtube-vdp-api';
    let youtubeScript = document.getElementById(youtubeScriptId);

    if (youtubeScript === null) {
      let tag = document.createElement('script');
      let firstScript = document.getElementsByTagName('script')[0];
      tag.src = 'https://www.youtube.com/iframe_api';
      tag.id = youtubeScriptId;
      firstScript.parentNode.insertBefore(tag, firstScript);
    }

    // runs only on first video
    window.onYouTubeIframeAPIReady = function () {
      // console.log('API is Ready, creating player');
      ytPLAYER = new window.YT.Player(video, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
          origin: window.location.origin,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onError: onPlayerError,
        },
      });
      APIReady = true;

      // console.log('Playe created, APIReady: ', APIReady, ' with this video: ', ytPLAYER);
    };

    function onPlayerReady(event) {
      // console.log('onPlayerReady', ytPLAYER);
    }

    function onPlayerError(event) {
      // console.log('onPlayerError', ytPLAYER);
    }

    function onPlayerStateChange(event) {
      const state = event.data;
      if (state === YT.PlayerState.ENDED) {
        // console.log('⏸️ Video ENDED');
      } else if (state === YT.PlayerState.PAUSED) {
        // console.log('⏸️ Video paused');
      } else if (state === YT.PlayerState.PLAYING) {
        // console.log('▶️ Video playing');
      }
    }

    $vdpGallerySlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      // console.log('BEFORE CHANGE FIRED', currentSlide);
      // console.log(currentSlide);
      const $currentSlide = $(`.slick-slide[data-slick-index=${currentSlide}]`);
      if ($currentSlide.find('.masonry-gallery__item-video').length != 0) {
        runVideoProgram(false);
      }
    });

    $('.video-control').on('click', function () {
      runVideoProgram();
    });

    $('.video-swipe').on('click', function () {
      $galleryVideoContainer.removeClass('sleeping');
      setTimeout(function () {
        $galleryVideoContainer.addClass('sleeping');
      }, 3000);
    });

    // stops the video on modal close
    $('.js-open-gallery-modal').on('click', function () {
      MicroModal.show('modal-vdp-gallery', {
        onClose: (modal, element) => {
          if (ytPLAYER.getPlayerState()) {
            runVideoProgram(false);
          }
        },
      });
    });

    function runVideoProgram(continuePlay = true) {
      if (type == 'youtube') {
        try {
          const playerState = ytPLAYER.getPlayerState();
          // console.log('playerState: ', playerState);
          if ((playerState == 5 || playerState == 2) && continuePlay) {
            // console.log('YT video is cued up or paused, starting play');
            runPlayVideo(ytPLAYER);
          } else if (playerState == 1) {
            // console.log('YT video is playing on this slide, pausing video ||');
            runStopVideo(ytPLAYER);
          } else {
            // console.log('do nothing');
          }
        } catch (err) {
          console.log('threw error on slide: ', ytPLAYER);
        }
      } else {
        // console.log('uploaded video is playing on this slide, pausing video ||');
      }
    }

    function runPlayVideo(player) {
      player.playVideo();
      $galleryVideoContainer.removeClass('paused');
      $galleryVideoContainer.addClass('playing');
      setTimeout(function () {
        $galleryVideoContainer.addClass('sleeping');
      }, 3000);
    }
    function runStopVideo(player) {
      player.pauseVideo();
      $galleryVideoContainer.removeClass('playing');
      $galleryVideoContainer.addClass('paused');
      setTimeout(function () {
        $galleryVideoContainer.addClass('sleeping');
      }, 3000);
    }
  }
});
